import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  margin-bottom: 10px;

  display: flex;
  flex-direction: column;

  > label {
    font-weight: bold;
  }

  > span {
    margin-top: 2px;

    font-size: 12px;
    color: var(--primary);
    /* display: none; */
  }
`;

export const Sufix = styled.div`
  position: relative;

  > input {
    width: calc(100% - 30px);
    padding-left: 25px;
  }

  ::after {
    content: "R$";

    font-weight: bold;

    position: absolute;
    left: 0;
    bottom: 7px;
  }
`;
